import React from 'react';
import { useDispatch } from 'react-redux';
import { BellIcon, CalendarIcon, HollowCamIcon, StarIcon, WaveIcon } from '@surfline/quiver-react';
import { color } from '@surfline/quiver-themes';
import { showForm as navigate } from '../../../../actions/navigation';
import { LEARN_MORE } from '../../../../common/constants';

const features = [
  {
    icon: StarIcon,
    text: 'Access your Favorite Spots from any device',
  },
  {
    icon: HollowCamIcon,
    text: 'View 600+ Cams, including Premium HD & Multi-Cam',
  },
  {
    icon: WaveIcon,
    text: 'Get Surf Reports for 4,000+ spots worldwide',
  },
  {
    icon: CalendarIcon,
    text: 'Plan ahead with 17-day Forecasts & Expert Analysis',
  },
  {
    icon: BellIcon,
    text: `Get notified when it's firing with Surf Alerts`,
  },
];

const FeatureMatrix = () => {
  const dispatch = useDispatch();
  return (
    <div className="sl-meter-feature-matrix">
      <div className="sl-meter-feature-matrix__features">
        {features.map(({ icon: Icon, text }) => (
          <div key={text} className="sl-meter-feature-matrix__feature">
            <div className="sl-meter-feature-matrix__feature--icon">
              <Icon stroke={color('dark-blue', 10)} />
            </div>
            <div className="sl-meter-feature-matrix__feature--text">{text}</div>
          </div>
        ))}

        <button
          type="button"
          onClick={() => dispatch(navigate(LEARN_MORE))}
          className="sl-meter-feature-matrix__learn-more"
        >
          Learn More
        </button>
      </div>
    </div>
  );
};

export default FeatureMatrix;
